export const CLICKSIGN_WIDGET_ENDPOINT = "https://app.clicksign.com";
export const CLICKSIGN_CONTAINER_ID = "owner-dashboard-clicksign-container";
export const PENDING_SIGNATURES_REFRESH_DELAY_MS = 2500;
